import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

import { IS_PRODUCTION } from 'services/environment';

//Main Bugsnag
export const mainBugsnag = Bugsnag.start({
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
  collectUserIp: false,
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY as string,
  plugins: [new BugsnagPluginReact()],
  onError: function (event) {
    if (!IS_PRODUCTION) {
      console.log('error from mainBugsnag :>> ', event);
      return false;
    }

    return true;
  },
});

// CRS Bugsnag
export const crsBugsnag = Bugsnag.createClient({
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
  collectUserIp: false,
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_CRS_API_KEY as string,
  plugins: [new BugsnagPluginReact()],
  onError: function (event) {
    if (!IS_PRODUCTION) {
      console.log('error from crsBugsnag :>> ', event);
      return false;
    }

    return true;
  },
});

// Create error boundary components for each client
export const MainErrorBoundary = mainBugsnag.getPlugin('react').createErrorBoundary(React);
export const CrsErrorBoundary = crsBugsnag.getPlugin('react').createErrorBoundary(React);
